<template>
  <custom-layout />
</template>

<script>
// import { v4 as uuidv4 } from 'uuid';
import CustomLayout from './components/CustomLayout.vue';

export default {
  name: 'App',
  components: {
    CustomLayout,
  },
  // provide() {
  //   return {
  //     uuid: uuidv4()
  //   };
  // }
};
</script>